import gql from 'graphql-tag';
import RecipeTagFragment from './RecipeTag.gql';

export default gql`
  fragment UserRecipeFragment on UserRecipe {
    userRecipeId
    recipeId
    notes
    tags {
      ...RecipeTagFragment
    }
  }
  ${RecipeTagFragment}
`;
